import React from "react";
import { Toaster } from "react-hot-toast";
import { BrowserRouter as Router, Routes, Route } from "react-router-dom";
import Banner from "./components/Banner";
import Navbar from "./components/Navbar";
import Footer from "./components/Footer";
import CartSidebar from "./components/CartSidebar";
import SignUpSidebar from "./components/SignUpSidebar";
import WishlistSidebar from "./components/WishlistSidebar";
import ScrollToTop from "./components/ScrollToTop";
import Home from "./pages/Home";
import About from "./pages/About";
import Store from "./pages/Store";
import Blogs from "./pages/Blogs";
import Contact from "./pages/Contact";
import ReturnPage from "./pages/ReturnPage";
import PhotoBooth from "./pages/PhotoBooth";
import Admin from "./pages/Admin";
import AdminRoute from "./components/AdminRoute";
import ProductPage from "./pages/ProductPage";
import SignUp from "./pages/SignUp";
import FaqsPage from "./pages/FaqsPage";
import Orders from "./pages/Orders";
import Checkout from "./pages/Checkout";
import OrderTracking from "./pages/OrderTracking";
import PublicTracking from "./pages/PublicTracking";
import CursorFollower from "./components/CursorFollower";
import "./App.css";
import NewBlog from "./pages/NewBlog";
import ExchangePage from "./pages/ExchangePage";
import PrivacyPage from "./pages/PrivacyPage";
import TermsPage from "./pages/TermsPage";

function App() {
  return (
    <Router>
      <div className="App">
        <ScrollToTop />
        <Toaster
          position="top-right"
          containerStyle={{ zIndex: 13000 }}
          toastOptions={{
            // Default options for all toasts
            duration: 4000,
            style: {
              background: "#111",
              color: "#fff",
              borderRadius: 10,
              padding: "12px 14px",
              boxShadow: "0 6px 20px rgba(0,0,0,0.2)",
            },
            // subtle monochrome icon for all toasts
            icon: (
              <svg
                width="16"
                height="16"
                viewBox="0 0 24 24"
                fill="none"
                xmlns="http://www.w3.org/2000/svg"
                style={{ color: "#fff" }}
              >
                <circle
                  cx="12"
                  cy="12"
                  r="9"
                  stroke="currentColor"
                  strokeWidth="1.5"
                />
              </svg>
            ),
            // Default icon styles can be overridden here
            success: {
              // use neutral monochrome icon
              icon: (
                <svg
                  width="16"
                  height="16"
                  viewBox="0 0 24 24"
                  fill="none"
                  xmlns="http://www.w3.org/2000/svg"
                  style={{ color: "#fff" }}
                >
                  <circle
                    cx="12"
                    cy="12"
                    r="9"
                    stroke="currentColor"
                    strokeWidth="1.5"
                  />
                </svg>
              ),
              style: {
                background: "#111",
                color: "#fff",
              },
            },
            error: {
              icon: (
                <svg
                  width="16"
                  height="16"
                  viewBox="0 0 24 24"
                  fill="none"
                  xmlns="http://www.w3.org/2000/svg"
                  style={{ color: "#fff" }}
                >
                  <circle
                    cx="12"
                    cy="12"
                    r="9"
                    stroke="currentColor"
                    strokeWidth="1.5"
                  />
                </svg>
              ),
              style: {
                background: "#111",
                color: "#fff",
              },
            },
          }}
        />
        <CartSidebar />
        <WishlistSidebar />
        <SignUpSidebar />
        <CursorFollower />
        <Routes>
          <Route
            path="/"
            element={
              <>
                <Banner />
                <Navbar />
                <div className="page-content">
                  <Home />
                </div>

                <Footer />
              </>
            }
          />
          <Route
            path="/product/:productSlug"
            element={
              <>
                <div className="page-content">
                  <Banner />
                  {/* <Navbar /> */}
                  <ProductPage />
                </div>

                <Footer />
              </>
            }
          />
          <Route
            path="/about"
            element={
              <>
                <div className="page-content">
                  <About />
                </div>
                <Footer />
              </>
            }
          />
          <Route
            path="/blog"
            element={
              <div>
                <NewBlog />
              </div>
            }
          />
          <Route
            path="/store"
            element={
              <>
                <div className="page-content">
                  <Banner />
                  {/* <Navbar /> */}
                  <Store />
                </div>
                <Footer />
              </>
            }
          />
          <Route
            path="/faqs"
            element={
              <>
                <div className="page-content">
                  <Banner />
                  <FaqsPage />
                </div>
                <Footer />
              </>
            }
          />
          <Route
            path="/return-policy"
            element={
              <>
                <div className="page-content">
                  <Banner />
                  <ReturnPage />
                </div>
                <Footer />
              </>
            }
          />
          <Route
            path="/exchange-policy"
            element={
              <>
                <div className="page-content">
                  <Banner />
                  <ExchangePage />
                </div>
                <Footer />
              </>
            }
          />
          <Route
            path="/privacy-policy"
            element={
              <>
                <div className="page-content">
                  <Banner />
                  <PrivacyPage />
                </div>
                <Footer />
              </>
            }
          />
          <Route
            path="/terms-of-service"
            element={
              <>
                <div className="page-content">
                  <Banner />
                  <TermsPage />
                </div>
                <Footer />
              </>
            }
          />
          <Route
            path="/blogs"
            element={
              <>
                <div className="page-content">
                  <Banner />
                  {/* <Navbar /> */}
                  <Blogs />
                </div>
                <Footer />
              </>
            }
          />
          {/* 
          
          <Route
            path="/blog/:blogId"
            element={
              <>
                <div className="page-content">
                  <Banner />
                  <Navbar />
                  <BlogPage />
                </div>
                <Footer />
              </>
            }
          /> */}
          <Route
            path="/contact"
            element={
              <>
                <div className="page-content">
                  <Banner />
                  <Contact />
                </div>
                <Footer />
              </>
            }
          />
          <Route
            path="/photo-booth"
            element={
              <>
                <div className="page-content">
                  <Banner />
                  {/* <Navbar /> */}
                  <PhotoBooth />
                </div>
                <Footer />
              </>
            }
          />
          <Route
            path="/orders"
            element={
              <>
                <div className="page-content">
                  <Banner />
                  {/* <Navbar /> */}
                  <Orders />
                </div>
                <Footer />
              </>
            }
          />
          <Route
            path="/orders/:orderId/track"
            element={
              <>
                <div className="page-content">
                  <Banner />
                  {/* <Navbar /> */}
                  <OrderTracking />
                </div>
                <Footer />
              </>
            }
          />
          <Route
            path="/track"
            element={
              <>
                <div className="page-content">
                  <Banner />
                  <PublicTracking />
                </div>
                <Footer />
              </>
            }
          />
          <Route
            path="/checkout"
            element={
              <>
                <div className="page-content">
                  <Banner />
                  <Checkout />
                </div>
                <Footer />
              </>
            }
          />
          <Route
            path="/sign-up"
            element={
              <>
                <div className="page-content">
                  <Banner />
                  {/* <Navbar /> */}
                  <SignUp />
                </div>
                <Footer />
              </>
            }
          />{" "}
          {/* Sign-up is now a sidebar — route removed */}
          <Route
            path="/admin"
            element={
              <>
                <div className="">
                  <AdminRoute>
                    <Admin />
                  </AdminRoute>
                </div>
              </>
            }
          />
        </Routes>
      </div>
    </Router>
  );
}

export default App;
